import { render } from "./InstructorsCard.vue?vue&type=template&id=00514694&scoped=true"
import script from "./InstructorsCard.vue?vue&type=script&lang=js"
export * from "./InstructorsCard.vue?vue&type=script&lang=js"

import "./InstructorsCard.vue?vue&type=style&index=0&id=00514694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00514694"]])

export default __exports__